import { getExplorerLink, } from "@bracket/chainography";
import type { BlockHash, } from "@bracket/types";
import type { Notification } from "@bracket/ui";
import type { ResolverResult, } from "@types";
import { wagmiConfig as config, } from "@wagmiconfig";
import { getChainId, } from "wagmi/actions";



export const dispatchWrappedNotification = (result: ResolverResult): Omit<Notification, "id"> | null => {
	if(result.success) {
		return wrappedSuccessNotification(result.hash);
	}
	if(result.rejected) {
		return null;
	}
	return wrappedFailedNotification(result.error);
}


export const wrappedSuccessNotification = (
	hash: BlockHash,
	token: string,
	amount: string,
): Omit<Notification, "id"> => {
	return {
		title: "Wrap successful",
		message: `You successfully wrapped ${amount} ${token}`,
		type: "success",
		status: "success",
		primaryAction: {
			label: "View on explorer",
			onClick: () => {
				window.open(getExplorerLink(hash, getChainId(config)), "_blank");
			},
		},
	}
}


export const wrappedFailedNotification = (error: Error): Omit<Notification, "id"> => {

  const msg = error.message.toLowerCase();
	const message = (
		// msg.includes("not a weistring") ? "invalid input, please check your values and try again" :
		// msg.includes("vaultnotlocked") ? "vault is not locked, please lock the vault before updating the NAV" :
		"please try again"
	);

	console.warn("wrapping failed", error.message);

	return {
		title: "Wrapping failure",
		message: `Failed to wrap, ${message}`,
		type: "error",
		status: "error",
	}

}
